
























































import { defineComponent, ref, onMounted } from "@vue/composition-api";
import { eventHub } from "@/utils/eventHub";
import { useMainStore } from "@/store/main";

/**
 * 头部导航
 */
export default defineComponent({
  props: {
    title: {
      type: String,
      default: "圈一圈地",
    },
    isIcon: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["back"],
  setup(_, { emit }) {
    const isShowSearch = ref(false);
    const isAnimation = ref(false);

    const handleSearchCancel = () => {
      isShowSearch.value = false;
      isAnimation.value = true;
    };

    const handleSearch = () => {
      isShowSearch.value = true;
    };

    const handleAfterLeave = () => {
      isAnimation.value = false;
    };

    const hanldeCity = () => {
      emit("on-city-click");
    };

    onMounted(() => {
      eventHub.$on("map-center-title-handle", () => {
        isShowSearch.value = false;
        isAnimation.value = true;
      });
    });

    return {
      mainStore: useMainStore(),
      isAnimation,
      isShowSearch,
      handleSearchCancel,
      handleSearch,
      handleAfterLeave,
      hanldeCity,
    };
  },
});
